/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiPromsyConfiguration as __Configuration } from '../api-promsy-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class NotificacionService extends __BaseService {
  static readonly EnvioNotificacionesDiariasProductoPostAsyncPath = '/EnvioNotificacionesDiariasProducto';
  static readonly EnvioNotificacionesDiariasProductoPostAsync_1Path = '/EnvioNotificacionPrecioListaProducto';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * PostAsync EnvioNotificacionesDiariasProducto
   * @return OK
   */
  EnvioNotificacionesDiariasProductoPostAsyncResponse(): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/EnvioNotificacionesDiariasProducto`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * PostAsync EnvioNotificacionesDiariasProducto
   * @return OK
   */
  EnvioNotificacionesDiariasProductoPostAsync(): __Observable<{}> {
    return this.EnvioNotificacionesDiariasProductoPostAsyncResponse().pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * PostAsync EnvioNotificacionesDiariasProducto
   * @param params The `NotificacionService.EnvioNotificacionesDiariasProductoPostAsync_1Params` containing the following parameters:
   *
   * - `idProducto`:
   *
   * - `Authorization`: Autorización (Ejemplo: "Bearer Token")
   *
   * @return OK
   */
  EnvioNotificacionesDiariasProductoPostAsync_1Response(params: NotificacionService.EnvioNotificacionesDiariasProductoPostAsync_1Params): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.idProducto != null) __params = __params.set('idProducto', params.idProducto.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/EnvioNotificacionPrecioListaProducto`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * PostAsync EnvioNotificacionesDiariasProducto
   * @param params The `NotificacionService.EnvioNotificacionesDiariasProductoPostAsync_1Params` containing the following parameters:
   *
   * - `idProducto`:
   *
   * - `Authorization`: Autorización (Ejemplo: "Bearer Token")
   *
   * @return OK
   */
  EnvioNotificacionesDiariasProductoPostAsync_1(params: NotificacionService.EnvioNotificacionesDiariasProductoPostAsync_1Params): __Observable<{}> {
    return this.EnvioNotificacionesDiariasProductoPostAsync_1Response(params).pipe(
      __map(_r => _r.body as {})
    );
  }
}

module NotificacionService {

  /**
   * Parameters for EnvioNotificacionesDiariasProductoPostAsync_1
   */
  export interface EnvioNotificacionesDiariasProductoPostAsync_1Params {
    idProducto: string;

    /**
     * Autorización (Ejemplo: "Bearer Token")
     */
    Authorization?: string;
  }
}

export { NotificacionService }
